export const SET_DISTRIBUTOR = 'SET_DISTRIBUTOR'
export const SET_CONNECT_FORM = 'SET_CONNECT_FORM'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
